<div [formGroup]="pumpScheduleForm">
  <div class="panel panel-custom no-padding">
    <div class="panel-heading">Total Job{{ jobProcedureTabName ? ' - ' + jobProcedureTabName : '' }}</div>
    <div class="panel-body">
      <div class="ui-table">
        <table>
          <thead>
            <tr>
              <th *ngIf="dryWeightVisible">Dry Weight</th>
              <th *ngIf="dryVolumeVisible">Dry Volume</th>
              <th *ngIf="cogsVisible$ | async">COGS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td *ngIf="dryWeightVisible" class="vertical-align-middle">
                <span class="unit-value" [apiValue]="dryWeight$ | async" [unitType]="UnitType.Weight"></span>
              </td>
              <td *ngIf="dryVolumeVisible" class="vertical-align-middle">
                <div class="unit-value" [apiValue]="dryVolume$ | async" [unitType]="UnitType.DryVolume"></div>
                <div *ngIf="anyMaterialMissingBulkDensity$ | async">
                  <span class="warning pr-1">Not all Bulk Densities available</span>
                  <span class="fa fa-question-circle icon-help pl-1" (click)="showMissingBulkDensityHelp()"></span>
                </div>
              </td>
              <td *ngIf="cogsVisible$ | async" class="vertical-align-middle">
                <div *ngIf="!(cogsAvailable$ | async)">
                  <span class="warning pr-1">Not all COGS available</span>
                  <span class="fa fa-question-circle icon-help pl-1" (click)="showCogsHelp()"></span>
                </div>
                <span *ngIf="cogsAvailable$ | async" class="unit-value">${{ cogs$ | async | number: '.2-2' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div> 
